module.exports = __webpack_public_path__ + "img/tour-detail-icon.60cbda24.svg";